import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppBar, Box, Toolbar } from '@mui/material';
import { RootState } from 'client';

import { requestUserOrganizations } from '@atom/actions/organizationActions';
import { triggerLogout } from '@atom/actions/userActions';
import Logo from '@atom/components/common/navigation/Logo';
import { Progress } from '@atom/mui';
import { getUserTenants } from '@atom/selectors/userSelectors';
import colors from '@atom/styles/colors';
import layoutStyles from '@atom/styles/layout';
import accountUtilities from '@atom/utilities/accountUtilities';
import history from '@atom/utilities/history';

import LoginFooter from './LoginFooter';
import TenantSelectionRow from './TenantSelectionRow';

import './login.css';

const navBarStyle = {
  height: layoutStyles.topNavHeight,
  backgroundColor: colors.neutral.white,
  boxShadow: '0 2px 4px 1px',
  color: colors.utility.boxShadow,
  position: 'fixed',
  top: 0,
};

export interface Organization {
  domain: string;
  id: string;
  isActive: boolean;
  isVerified: boolean;
  name: string;
  role: string;
}

const TenantSelection = () => {
  const email = accountUtilities.getLoggedInEmail();

  if (!email) {
    history.push('/login');
  }

  const dispatch = useDispatch();
  const organizations = useSelector((state: RootState) =>
    getUserTenants(state.organizations),
  );
  const loading = useSelector(
    (state: RootState) => state.loading.loadingOrganizations,
  );

  useEffect(() => {
    dispatch(requestUserOrganizations());
  }, []);

  const logout = () => {
    dispatch(triggerLogout());
  };

  const content = loading ? (
    <div styleName="spinner-container">
      <Progress />
    </div>
  ) : (
    <div styleName="tenants-container">
      {organizations.map((organization: Organization, index: number) => (
        <TenantSelectionRow
          key={`${organization.id}-${index}`}
          organization={organization}
        />
      ))}
      <div styleName="tenant-selection-container">
        <div>Cannot find the team you are looking for?</div>
        <div styleName="tenant-decision-container">
          <Link to="/tenant-entry">
            <div styleName="tenant-selection-link">Join a workspace</div>
          </Link>
          or
          <Link to="/tenant-creation">
            <div styleName="tenant-selection-link">Create a workspace</div>
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <AppBar style={navBarStyle}>
        <Toolbar>
          <div>
            <Logo />
          </div>
          <Box sx={{ flexGrow: 1 }} />
          <div styleName="nav-right-container">
            <div styleName="nav-right-text">{email}</div>
            <div styleName="nav-right-login" onClick={logout}>
              Sign Out
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <div styleName="container">
        <div styleName="auth-background partial" />
        <div styleName="heading-text">Choose a workspace</div>
        {content}
        <LoginFooter />
      </div>
    </>
  );
};

export default TenantSelection;
